

import JsBarcode from "jsbarcode";


export function consignmentPrint(order_id,receiver,destination,freight_type,print_number){
    let TYD_print_html = `
        <!DOCTYPE html>
<html>
<head>
<style>
table {
  border-collapse: collapse;
  width: 100%; /* 设置表格宽度 */
  /*width: 368px !* 设置表格宽度 *!*/
  height: 240px /* 设置表格高度 */
}

td {
  /*border: 1px solid black; !* 添加边框线，可以根据需要调整线的样式和颜色 *!*/
  border: 0px solid Gray; /* 添加边框线，可以根据需要调整线的样式和颜色 */
  padding: 1px; /* 设置单元格内边距 */
  text-align: center; /* 文本居中对齐 */
}

        body {
            font-family: "Microsoft YaHei",微软雅黑,"MicrosoftJhengHei";
              font-weight: bold; /* 设置粗体 */
            /*font-size: 200%;*/
            font-size: 32px;

        }

            caption {
        font-weight: bold;
        font-size: 120%;

    }


</style>

</head>
<body>
||all_table||

<!--<ta<!--<caption>YT</caption>-->
<!--  <tr>-->
<!--    <td>货&emsp;号&emsp;:&emsp;||order_id||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>地&emsp;址&emsp;:&emsp;||destination||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>收&emsp;货&emsp;:&emsp;||receiver||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>方&emsp;式&emsp;:&emsp;||freight_type||</td>-->
<!--  </tr>-->
<!--</table>-->
</body>
</html>

`

    let table2 = `
    <table>
<caption>YT</caption>
  <tr>
    <td>货&emsp;号:||order_id||</td>
  </tr>
  <tr>
    <td>地&emsp;址:||destination||</td>
  </tr>
  <tr>
    <td>收&emsp;货:||receiver||</td>
  </tr>
  <tr>
    <td>方&emsp;式:||freight_type||</td>
  </tr>
</table>    
    `

    let table = `
    <table>
<caption>YT</caption>
  <tr>
    <td width='20%' height="100px">NO:</td>
    <td style="font-size:40px">||order_id||
    </td>
  </tr>
  
  <tr>
    <td width="20%"  style="font-size:20px" >Địa chỉ:</td>
    <td style="font-size:30px">||destination||</td>
  </tr>  
  <tr>
    <td width="20%"   style="font-size:20px" >Người nhận:</td>
    <td style="font-size:30px">||receiver||</td>
  </tr>
  
</table>    
    `



    let table3 = `
    <table>
<caption>YT</caption>
  <tr>
    <td width="100px">货号:<br>
    地址:<br>
    收货:<br>
    方式:</td>
    <td>||order_id||<br>
    ||destination||<br>
    ||receiver||<br>
    ||freight_type||
    </td>
  </tr>
</table>    
    `




    try {


    if (destination.length == 2){
        let destination_0 =  destination.slice(0,1);
        let destination_1 =  destination.slice(1,2);
        destination = destination_0 + '&emsp;&emsp;' + destination_1
    }}catch (err){
        destination = ''
    }
    try {
        if (freight_type.length == 2) {
            let freight_type_0 = freight_type.slice(0, 1);
            let freight_type_1 = freight_type.slice(1, 2);
            freight_type = freight_type_0 + '&emsp;&emsp;' + freight_type_1
        }
    }catch (err){
        freight_type = ''
    }

    table = table.replace("||order_id||",order_id)
    table = table.replace("||receiver||",receiver)
    table = table.replace("||destination||",destination)
    table = table.replace("||freight_type||",freight_type)
    let all_table = ''
    let i =0
   while (i < print_number) {
        all_table = all_table + table
       i++
    }
    TYD_print_html = TYD_print_html.replace("||all_table||",all_table)

    // console.log(all_table)




    return TYD_print_html;
}


export function consignmentPrint2(order_id,receiver,destination,freight_type,print_number){
    let TYD_print_html = `
        <!DOCTYPE html>
<html>
<head>
<style>
table {
  border-collapse: collapse;
  /*width: 100%; !* 设置表格宽度 *!*/
  width: 368px /* 设置表格宽度 */
  height: 300px /* 设置表格高度 */
}

td {
  /*border: 1px solid black; !* 添加边框线，可以根据需要调整线的样式和颜色 *!*/
  border: 0px solid Gray; /* 添加边框线，可以根据需要调整线的样式和颜色 */
  padding: 1px; /* 设置单元格内边距 */
  text-align: center; /* 文本居中对齐 */
}

        body {
            font-family: "Microsoft YaHei",微软雅黑,"MicrosoftJhengHei";
              font-weight: bold; /* 设置粗体 */
            /*font-size: 200%;*/
            font-size: 32px;

        }

            caption {
        font-weight: bold;
        font-size: 120%;

    }


</style>

</head>
<body>
||all_table||

<!--<ta<!--<caption>YT</caption>-->
<!--  <tr>-->
<!--    <td>货&emsp;号&emsp;:&emsp;||order_id||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>地&emsp;址&emsp;:&emsp;||destination||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>收&emsp;货&emsp;:&emsp;||receiver||</td>-->
<!--  </tr>-->
<!--  <tr>-->
<!--    <td>方&emsp;式&emsp;:&emsp;||freight_type||</td>-->
<!--  </tr>-->
<!--</table>-->
</body>
</html>

`

    let table2 = `
    <table>
<caption>YT</caption>
  <tr>
    <td>货&emsp;号:||order_id||</td>
  </tr>
  <tr>
    <td>地&emsp;址:||destination||</td>
  </tr>
  <tr>
    <td>收&emsp;货:||receiver||</td>
  </tr>
  <tr>
    <td>方&emsp;式:||freight_type||</td>
  </tr>
</table>    
    `

    let table = `
    <table>
<caption>YT</caption>
  <tr>
    <td width="60px">货号:
    <td style="font-size:40px">||order_id||
    </td>
  </tr>
  <tr>
      <td width="100px" height="100px">
    地址:<br>
    收货:
    <td>
    ||destination||<br>
    ||receiver||
    </td>
  </tr>
</table>    
    `



    let table3 = `
    <table>
<caption>YT</caption>
  <tr>
    <td width="100px">货号:<br>
    地址:<br>
    收货:<br>
    方式:</td>
    <td>||order_id||<br>
    ||destination||<br>
    ||receiver||<br>
    ||freight_type||
    </td>
  </tr>
</table>    
    `




    try {


        if (destination.length == 2){
            let destination_0 =  destination.slice(0,1);
            let destination_1 =  destination.slice(1,2);
            destination = destination_0 + '&emsp;&emsp;' + destination_1
        }}catch (err){
        destination = ''
    }
    try {
        if (freight_type.length == 2) {
            let freight_type_0 = freight_type.slice(0, 1);
            let freight_type_1 = freight_type.slice(1, 2);
            freight_type = freight_type_0 + '&emsp;&emsp;' + freight_type_1
        }
    }catch (err){
        freight_type = ''
    }

    table = table.replace("||order_id||",order_id)
    table = table.replace("||receiver||",receiver)
    table = table.replace("||destination||",destination)
    table = table.replace("||freight_type||",freight_type)
    let all_table = ''
    let i =0
    while (i < print_number) {
        all_table = all_table + table
        i++
    }
    TYD_print_html = TYD_print_html.replace("||all_table||",all_table)

    // console.log(all_table)




    return TYD_print_html;
}


// WEBPACK FOOTER //
// ./src/printModel.js